export default __webpack_public_path__ + "535067ce22eeddf66d3971349720ffe4.png";